(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-base"] && !Shopify.designMode) return;
  try {
    (function () {
    function toggle(card) {
      var open = card.classList.toggle('is-open');
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = card.querySelector('[data-mp-expand-label]');
      if (label) label.textContent = open ? 'Show less' : 'Read more';
    }
    function setup() {
      document.querySelectorAll('[data-mp-expand]').forEach(function (card) {
        var text = card.querySelector('[data-mp-expand-text]');
        var label = card.querySelector('[data-mp-expand-label]');
        if (!text || !label || card.classList.contains('is-open')) return;
        label.hidden = text.scrollHeight <= text.clientHeight + 2;
      });
    }
    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-mp-expand]');
      if (!card || event.target.closest('a')) return;
      toggle(card);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('[data-mp-expand]');
      if (!card || event.target !== card) return;
      event.preventDefault();
      toggle(card);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    window.addEventListener('load', setup);
    window.addEventListener('resize', setup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-cart-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var clearing = false;
    function shipLabel(days) {
      var date = new Date();
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
      return date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var clock = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      document.querySelectorAll('[data-mp-cart-timer]').forEach(function (el) {
        var text = el.querySelector('[data-mp-cart-timer-text]');
        if (!text) return;
        var html = 'Order in <b>' + clock + '</b> to ship by ' + shipLabel(Number(el.dataset.shipDays || 1));
        if (text.innerHTML !== html) text.innerHTML = html;
      });
      document.querySelectorAll('[data-mp-ships-by]').forEach(function (el) {
        var label = 'Ships by ' + shipLabel(Number(el.dataset.shipDays || 1));
        if (el.textContent !== label) el.textContent = label;
      });
      /* Only free gifts left in the cart: empty it. */
      if (!clearing && document.querySelector('[data-mp-cart-orphans]')) {
        clearing = true;
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () { window.location.reload(); })
          .catch(function () { clearing = false; });
      }
    }
    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
